import { mount } from "@vue/test-utils";
import CheckItem from "@/components/core/custom/CheckItem";

jest.mock("@/components/core/custom/CheckItem", () => ({
  default: {
    latitude: {}
  }
}));

describe("CheckItem test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(CheckItem);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component CheckItem", () => {
    expect(wrapper).toBeDefined();
  });
});
